module.exports = __webpack_public_path__ + "static/media/VirtualTourist.a680f28c.png";